import React from 'react';
import Link from 'gatsby-link';
import WinterJumbo from '../components/WinterJumbo';
import DocsListing from '../components/DocsListing';


const IndexPage = () => (
  <div>

    <WinterJumbo
      title = "Wintersense Docs"
    />

    <br/>

    <DocsListing></DocsListing>

  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js